import React, { useEffect, useState } from "react";
import { Button, Box, Card, useMediaQuery } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Chip } from "@mui/material";

import { useGet } from "../../../services/hooks/useGet";
import { GetUrl } from "../../../api/endpointConfig";
import {
  CustomDataTable,
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { FundsInterface } from "../../../types/types";
import { colorCode } from "../../../styles/colorCode";
import { blue } from "@mui/material/colors";
import { useLoader } from "../../../Loader/LoaderContext";
import { useFundContext } from "../../../Context/FundManagementContext";
import { getStatusChipColor } from "../../../utils/common";

const FundManagementList: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setFundExpense } = useFundContext();
  const [offsetValue, setOffsetValue] = useState<number>(0);
  const [limitValue, setLimitValue] = useState<number>(10);
  const { showLoader, hideLoader } = useLoader();
  const [queryParams, setQueryParams] = useState<any>({});
  const [mainData, setMainData] = useState<FundsInterface[]>([]);

  const pagination: Record<string, string | number | null> = {
    offset: 0,
    limit: 0,
  };
  // ✅ Sync URL params → queryParams
    useEffect(() => {
      const prefix = searchParams.get("prefix");
      const text = searchParams.get("text");
  
      if (text && prefix) {
        setQueryParams({ [prefix]: text });
      } else {
        setQueryParams({});
      }
    }, [searchParams]);
  // const { data = [], isLoading, isError, error } = useGet<any>(
  // `${GetUrl.getAllFund}`, { params: {...pagination,...queryParams}}
  // );

  const getFundData = useGet<any>(`${GetUrl.getAllFund}`, {
    params: { ...pagination, ...queryParams },
  });
  // ✅ Loader handling
  useEffect(() => {
    if (getFundData.isLoading) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [getFundData.isLoading]);

  // ✅ Data binding
  useEffect(() => {
    if (getFundData.data) {
      setMainData(getFundData.data);
    }
  }, [getFundData.data]);

  // ✅ Pagination
  const handlePageChange = (event: any) => {
    setOffsetValue(event.page * event.rows);
    setLimitValue(event.rows);
  };

  const setClearFilterState = (state: boolean) => {
    if (state) setQueryParams({});
  };

  // useEffect(() => {
  //   if (isLoading && !isError) {
  //     showLoader()
  //   } else if (isError) { hideLoader() }
  //   else { hideLoader() }
  // }, [isLoading, isError])
  const isDesktop = useMediaQuery("(min-width:1025px)");
  const columns: TableColumn<FundsInterface>[] = [
    {
      field: "scholarship_id",
      frozen: isDesktop ? true : false,
      header: "Scholarship Id",
      sortable: true,
      filterable: true,
      width: "8rem",
      customBody: (row) => (
        <Button
          sx={{ color: blue[700], textDecoration: "underline" }}
          onClick={() => navigate(`/scholarship-summary/${row.user_id}`)}
        >
          {row.scholarship_id}
        </Button>
      ),
    },
    {
      field: "name",
      header: "Applicant Name",
      width: "12rem",
      sortable: true,
      filterable: true,
    },
    {
      field: "amount_paid_till_date",
      header: "Amount Paid",
      sortable: true,
      width: "8rem",
    },
    {
      field: "status",
      header: "Status",
      width: "4rem",
      sortable: true,
      filterable: true,
      customBody: (row) => (
        <Chip
          label={row.status}
          color={getStatusChipColor(row.status)}
          size="small"
          variant="filled"
          style={{ fontWeight: 600, textTransform: "capitalize" }}
        />
      ),
    },
    {
      field: "course",
      header: "Course",
      sortable: true,
      filterable: true,
      width: "14rem",
    },
    {
      field: "action",
      header: "Actions",
      width: "8rem",
      customBody: (row) => (
        <Box display={"flex"} gap={"0.5rem"}>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: colorCode.lightblue,
              padding: 0,
              minWidth: "12rem",
            }}
            onClick={() => {
              setFundExpense(row);
              navigate(`/fund-viewpayment/${row.id}`);
            }}
          >
            View Payment History
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={row.purpose?.length === 0}
            sx={{
              backgroundColor: colorCode.lightGreen,
              padding: 0,
              minWidth: "8rem",
            }}
            onClick={() => {
              setFundExpense(row);
              navigate(`/fund-addpayment/${row.id}`);
            }}
          >
            Add Payment
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: colorCode.oceanBlu,
              color: "#000",
              minWidth: "7rem",
            }}
            onClick={() => {
              setFundExpense(row);
              navigate(`/fund-viewexpense/${row.id}`);
            }}
          >
            View Expense
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Card
      style={{
        padding: "1rem",
        border: 0,
        boxShadow: "none",
        background: "none",
      }}
    >
      <Box className={"cardBoxUI"}>
        <CustomDataTable<FundsInterface>
          data={mainData}
          columns={columns}
          tableTitle="Fund Management"
          rowsPerPage={limitValue}
          first={offsetValue}
          rows={limitValue}
          exportExcelShow={true}
          onSearchClear={() => setQueryParams({})}
          onPageChange={handlePageChange}
          clearFilter={setClearFilterState}
        />
      </Box>
    </Card>
  );
};

export default FundManagementList;
